var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormInput } from "./ui/FormInput";
import { formatCPF } from "../../../utils/FormatCPF";
export function CitizenSection(_a) {
    var _b, _c, _d;
    var form = _a.form;
    var register = form.register, errors = form.formState.errors, setValue = form.setValue;
    return (_jsxs("section", __assign({ className: "space-y-4" }, { children: [_jsx("h2", __assign({ className: "text-lg font-semibold text-[#0f4098]" }, { children: "Dados do cidad\u00E3o" })), _jsx("div", __assign({ className: "space-y-1" }, { children: _jsx(FormInput, { label: "Nome completo", placeholder: "Digite seu nome completo", registration: register("fullName"), error: (_b = errors.fullName) === null || _b === void 0 ? void 0 : _b.message }) })), _jsxs("div", __assign({ className: "grid grid-cols-1 md:grid-cols-2 gap-4" }, { children: [_jsx("div", __assign({ className: "space-y-1" }, { children: _jsx(FormInput, { label: "E-mail", placeholder: "Digite seu e-mail", registration: register("email"), error: (_c = errors.email) === null || _c === void 0 ? void 0 : _c.message }) })), _jsx("div", __assign({ className: "space-y-1" }, { children: _jsx(FormInput, { label: "CPF", placeholder: "000.000.000-00", registration: register("cpf", {
                                onChange: function (e) {
                                    var formatted = formatCPF(e.target.value);
                                    setValue("cpf", formatted, { shouldValidate: true });
                                },
                            }), error: (_d = errors.cpf) === null || _d === void 0 ? void 0 : _d.message, maxLength: 14 }) }))] }))] })));
}
